<script lang="ts">
export default {
  name: 'KkImageTooltipContent',
}
</script>

<script lang="ts" setup>
export interface Props {
  count: string
  format: string
  width: string
  height: string
  size: string
  isVisibleResize: boolean
  resizeWidth?: boolean
  resizeHeight?: boolean
  isVisibleRecommendDescription?: boolean
  isVisibleSimpleDescription?: boolean
}

const props = defineProps<Props>()
</script>

<template>
  <dl class="tooltipContent">
    <dt>{{ $t('labels.imageTooltipContent.count.label') }}</dt>
    <dd>{{ $t('labels.imageTooltipContent.count.description', { count: props.count }) }}</dd>
    <dt>{{ $t('labels.imageTooltipContent.format') }}</dt>
    <dd>{{ props.format }}</dd>
    <template v-if="props.isVisibleSimpleDescription">
      <dt>{{ $t('labels.imageTooltipContent.fileInfo.simpleLabel') }}</dt>
      <dd>
        {{ $t(`labels.imageTooltipContent.fileInfo.simpleDescription`, { size: props.size }) }}
      </dd>
    </template>
    <template v-else>
      <dt>{{ $t('labels.imageTooltipContent.fileInfo.label') }}</dt>
      <dd>
        {{ $t(`labels.imageTooltipContent.fileInfo.${ props.isVisibleRecommendDescription ? 'recommendDescription' : 'description' }`, { width: props.width, height: props.height, size: props.size }) }}
      </dd>
    </template>
    <dd v-show="props.isVisibleResize">
      {{ $t('labels.imageTooltipContent.fileInfo.resizeDescription', { resizeWidth: props.resizeWidth, resizeHeight: props.resizeHeight }) }}
    </dd>
  </dl>
</template>

<style lang="scss" scoped>
.tooltipContent {
  font-size: 12px;
  dt {
    font-weight: bold;
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
}
</style>
